'use strict';

/**
 * Handler that hides / shows more refinement values
 */
function handleShowMoreClick() {
    const $this = $(this);
    const numVisibleFilterValues = $('.filter-content.refinements').data('num-visible-filter-values') || 4;

    if ($this.attr('data-collapsed-status') === 'collapsed') {
        $this.siblings('li').removeClass('d-none');
        $this.text($this.data('show-less'));
        $this.attr('data-collapsed-status', 'not-collapsed');
    }
    else {
        $this.siblings('li:gt(' + numVisibleFilterValues + ')').addClass('d-none');
        $this.text($this.data('show-more'));
        $this.attr('data-collapsed-status', 'collapsed');
    }
}

/**
 * Brand searchbar handler
 */
function handleBrandInputKeyup() {
    const $this = $(this);
    const $brandsSelector = $('.filter-component:visible .brands li');
    const searchParam = $this.val().toLowerCase();

    $brandsSelector.removeClass('d-none');

    if(!searchParam.length) {
        return;
    }
    
    //Hide brands that are not included in the search results
    $brandsSelector.each(function() {
        const li = $(this);
        const brandName = li.text();
        const match = brandName.toLowerCase().includes(searchParam);
        if(!match) {
            li.addClass('d-none');
        }
    });
}

/**
 * Selectors and events for fragua custom filters
 */
function initFilterTools() {
    const $showMore = $('.filter-component .show-more-filters');
    $showMore.on('click', handleShowMoreClick);

    const $brandSearch = $('.filter-component .brand-search');
    $brandSearch.on('keyup', handleBrandInputKeyup);
}

module.exports = {
    initFilterTools: initFilterTools
}